import { memo } from 'react';

import EmailFilledIconSVG from '@/assets/email-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IEmailFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={EmailFilledIconSVG} {...props} />
);

export const EmailFilledIcon = memo(IEmailFilledIcon) as typeof IEmailFilledIcon;
